import React from "react";
import { Box } from "@mui/material";
import ConnectBar from "components/ConnectivityBar";
import { buildConnectivityInfo } from "../helper";

export const getClientsColumns = ({ columnHelper, fromTime, toTime }) => {
  return [
    columnHelper.accessor("clientId", {
      header: "Client ID",
      cell: (info) => {
        const clientId = info.getValue();
        const clientName = info.row.original.clientName;
        return <Box>{clientId ?? clientName ?? "-"}</Box>
      },
    }),
    columnHelper.accessor("macAddress", {
      header: "MAC Address",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    columnHelper.accessor("vendor", {
      header: "Vendor",
      cell: (info) => <Box>{info.getValue() || "-"}</Box>,
    }),
    columnHelper.accessor("segments", {
      id: "connectivity",
      header: "Connectivity of the Week",
      cell: (info) => {
        const segments = info.getValue() || [];
        const connectData = buildConnectivityInfo(segments, fromTime, toTime);

        if (connectData.length === 0) {
          return <Box sx={{ width: "100%", textAlign: "center" }}>-</Box>;
        }

        return (
          <Box sx={{ width: "100%", pr: 2 }}>
            <ConnectBar
              info={connectData}
              startTime={fromTime}
              endTime={toTime}
            />
          </Box>
        );
      },
    }),
  ];
};
